export const REQUEST_STATUS = {
	IDLE: 'IDLE',
	SENDING: 'SENDING',
	SENT: 'SENT',
	BLOCKED: 'BLOCKED',
}
